import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Order from 'src/smoothr-web-app-core/models/Order';
import { numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-recalculation-price-modal',
	templateUrl: './recalculation-price-modal.component.html',
	styleUrls: ['./recalculation-price-modal.component.scss'],
	standalone: false,
})
export class RecalculationPriceModalComponent {
	verifiedOrder: Order;
	numberToCurrency = numberToCurrency;

	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController, verifiedOrder: Order): Promise<Boolean> {
		const modal = await modalCtrl.create({
			component: RecalculationPriceModalComponent,
			componentProps: {
				verifiedOrder,
			},
			cssClass: 'auto-height item-modal reduced-width-modal',
			showBackdrop: true,
			backdropDismiss: true,
		});

		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	close(res: boolean = false) {
		this.modalCtrl.dismiss(res);
	}
}
